import { Component, EventEmitter, Input, Output, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    SewButton,
    SewHeadline,
    SewLink,
    SewMarkdown,
    SewTooltip,
    SewWsRichtext,
} from '@sew/ui-components-angular/standalone';
import { ReplaceDoubleLinebreakPipe } from '../../pipes/replace-linebreaks/replace-linebreak.pipe';

export interface SearchHelpCriteriaContentText {
    type: 'text';
    text: string;
}

export interface SearchHelpCriteriaContentImage {
    type: 'image';
    src: string;
    alt: string;
    title: string;
}

export type SearchHelpCriteriaContent = SearchHelpCriteriaContentText | SearchHelpCriteriaContentImage;

export interface SearchHelpCriteria {
    headline: string;
    content: SearchHelpCriteriaContent[];
}

@Component({
    selector: 'osc-search-help',
    templateUrl: './search-help.component.html',
    styleUrls: ['./search-help.component.scss'],
    imports: [
        ReplaceDoubleLinebreakPipe,
        SewButton,
        SewHeadline,
        SewLink,
        SewMarkdown,
        SewTooltip,
        SewWsRichtext,
        TranslatePipe,
    ],
})
export class SearchHelpComponent {
    @Output() public closeClicked = new EventEmitter<boolean>();
    @Output() public latestSearchTermClicked = new EventEmitter<string>();

    @Input() public isMobile = false;
    @Input() public showLatestSearchTerms = true;
    @Input() public showSearchCriteria = true;
    @Input() public criteriaExplanation: readonly SearchHelpCriteria[] | null = null;

    public readonly latestSearchTerms = input<readonly string[] | null>(null);

    public loadMoreLatestSearchTerms = false;

    public readonly showToggleLoadMoreButton = computed(() => (this.latestSearchTerms()?.length ?? 0) > 5);

    public toggleLoadMoreSearchTerms(): void {
        this.loadMoreLatestSearchTerms = !this.loadMoreLatestSearchTerms;
    }

    public onLatestSearchResultSelected(searchTerm: string): void {
        this.latestSearchTermClicked.emit(searchTerm);
    }
}
